import { render, staticRenderFns } from "./zhuanti.vue?vue&type=template&id=54f3aa9a&scoped=true"
import script from "./zhuanti.vue?vue&type=script&lang=js"
export * from "./zhuanti.vue?vue&type=script&lang=js"
import style0 from "./zhuanti.vue?vue&type=style&index=0&id=54f3aa9a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54f3aa9a",
  null
  
)

export default component.exports